import type { VariantType, VariantTypeV2 } from "@shared/graphql.types";

type ItemType = {
  id: string;
  title: string;
};

export type IndexItemProps = {
  item: ItemType;
  activeItem: string;
};

export const getAvailableItemsInIndex = (
  variant: VariantType | VariantTypeV2,
  recommendationLength?: number | undefined
): ItemType[] => {
  const resultsTitle = variant?.trials?.title;

  let itemsInIndex = [
    {
      id: "about-this-product",
      title: "About this product"
    },
    {
      id: "how-to-use",
      title: "How to use"
    },
    {
      id: "results",
      title: resultsTitle ?? "Real results"
    },
    {
      id: "skin-quiz",
      title: "Skin Quiz"
    },
    {
      id: "community",
      title: "Community"
    },
    {
      id: "frequently-bought-together",
      title: "Frequently bought together"
    },
    {
      id: "reviews",
      title: "Reviews"
    }
  ];

  const hasHowToUseSlidesMedia = variant?.howToUseSlides?.filter(
    (slide) => slide?.imageOrVideo
  ).length;

  const hasHowToContent = variant?.howTo?.description || hasHowToUseSlidesMedia;

  if (!hasHowToContent) {
    itemsInIndex = itemsInIndex.filter((item) => item.id !== "how-to-use");
  }

  const hasRealResultsContent =
    (variant?.trials?.beforeImage && variant?.trials?.afterImage) ||
    variant?.trials?.results;
  if (!hasRealResultsContent) {
    itemsInIndex = itemsInIndex.filter((item) => item.id !== "results");
  }

  const hasCommunityVideo =
    variant.ugc?.ugcVideoLinkDash && variant.ugc?.ugcVideoLinkHls;

  if (!hasCommunityVideo) {
    itemsInIndex = itemsInIndex.filter((item) => item.id !== "community");
  }

  const hasFbtData = recommendationLength;

  if (!hasFbtData) {
    itemsInIndex = itemsInIndex.filter(
      (item) => item.id !== "frequently-bought-together"
    );
  }

  return itemsInIndex;
};
